export default __webpack_public_path__ + "static/media/gal-5.a2cc7456.jpeg";